import {Image} from "semantic-ui-react";
import React from "react";

export function CompanyLogo() {
  let src = "/generic-solar-logo.png";
  return <div>
    <Image src={src}/>
  </div>
}